import { withNamespaces } from "react-i18next";
import Select from "react-select";
import { Input, Label } from "reactstrap";

const selectMenuProps = {
    menuPortalTarget: typeof document !== "undefined" ? document.body : null,
    menuPosition: "fixed",
    styles: {
        menuPortal: (base) => ({
            ...base,
            zIndex: 2000,
        }),
    },
};

const FieldError = ({ error }) => {
    if (!error) {
        return null;
    }

    return <div className="invalid-feedback d-block">{error}</div>;
};

const DataFlowFormFields = ({
    purpose,
    notes,
    dataTypes,
    dataCategories,
    methods,
    identifier = "",
    identifierLabel = "Identifier",
    identifierOptional = false,
    showIdentifier = false,
    relation = null,
    relationOptions = [],
    showRelation = false,
    dataTypeOptions = [],
    dataCategoryOptions = [],
    methodOptions = [],
    errors = {},
    disabled = false,
    onPurposeChange,
    onNotesChange,
    onDataTypesChange,
    onDataCategoriesChange,
    onMethodsChange,
    onIdentifierChange,
    onRelationChange,
    t,
}) => {
    return (
        <div className="data-flow-v2__form-fields">
            {showRelation && (
                <div>
                    <Label className="form-label">{t("Relation")}</Label>
                    <Select
                        classNamePrefix="react-select"
                        options={relationOptions}
                        value={relation}
                        onChange={onRelationChange}
                        isClearable
                        isDisabled={disabled}
                        isOptionDisabled={(option) => option.isDisabled}
                        placeholder={t("Select...")}
                        {...selectMenuProps}
                    />
                    <FieldError error={errors.relation} />
                </div>
            )}

            <div>
                <Label className="form-label" for="data-flow-v2-purpose">
                    {t("Purpose")}
                </Label>
                <Input
                    id="data-flow-v2-purpose"
                    type="text"
                    value={purpose}
                    onChange={(event) => onPurposeChange(event.target.value)}
                    placeholder={t("e.g. Candidate application intake")}
                    disabled={disabled}
                />
                <FieldError error={errors.purpose} />
            </div>

            <div>
                <Label className="form-label">{t("Data Types")}</Label>
                <Select
                    classNamePrefix="react-select"
                    options={dataTypeOptions}
                    value={dataTypes}
                    onChange={(value) => onDataTypesChange(value || [])}
                    isMulti
                    isDisabled={disabled}
                    placeholder={t("Select...")}
                    {...selectMenuProps}
                />
                <FieldError error={errors.data_types} />
            </div>

            <div>
                <Label className="form-label">{t("Data Categories")}</Label>
                <Select
                    classNamePrefix="react-select"
                    options={dataCategoryOptions}
                    value={dataCategories}
                    onChange={(value) => onDataCategoriesChange(value || [])}
                    isMulti
                    isDisabled={disabled}
                    placeholder={t("Select...")}
                    {...selectMenuProps}
                />
                <FieldError error={errors.data_categories} />
            </div>

            <div>
                <Label className="form-label">{t("Transfer Methods")}</Label>
                <Select
                    classNamePrefix="react-select"
                    options={methodOptions}
                    value={methods}
                    onChange={(value) => onMethodsChange(value || [])}
                    isMulti
                    isDisabled={disabled}
                    placeholder={t("Select...")}
                    {...selectMenuProps}
                />
                <FieldError error={errors.methods} />
            </div>

            {showIdentifier && (
                <div>
                    <Label
                        className="form-label"
                        for="data-flow-v2-identifier"
                    >
                        {t(identifierLabel)}
                        {identifierOptional ? ` ${t("(optional)")}` : null}
                    </Label>
                    <Input
                        id="data-flow-v2-identifier"
                        type="text"
                        value={identifier}
                        onChange={(event) =>
                            onIdentifierChange(event.target.value)
                        }
                        disabled={disabled}
                    />
                    <FieldError error={errors.identifier} />
                </div>
            )}

            <div>
                <Label className="form-label" for="data-flow-v2-notes">
                    {t("Notes (optional)")}
                </Label>
                <Input
                    id="data-flow-v2-notes"
                    type="textarea"
                    rows={3}
                    value={notes}
                    onChange={(event) => onNotesChange(event.target.value)}
                    placeholder={t("Internal notes...")}
                    disabled={disabled}
                />
                <FieldError error={errors.notes} />
            </div>
        </div>
    );
};

export default withNamespaces()(DataFlowFormFields);
